var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata f-df f-ai f-jc",style:({height: _vm.height + 'px'})},[_c('figure',{staticClass:"ndpic"},[_c('img',{attrs:{"src":_vm.imgSrc,"width":"100%"}})]),(!_vm.isHasSolt)?_c('p',{staticClass:"f-tac nodatatxt"},[_vm._v(_vm._s(_vm.warntxts))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }